import { Component, Output, EventEmitter, Input } from '@angular/core';
@Component({
    selector: 'topic-selection-list',
    styles: [`
        mat-list-item.mat-list-option.mat-list-item-with-avatar {
            height: 80px;
        }
    `],
    template: `
        <mat-selection-list (selectionChange)="selectionChange.emit($event)">
            <mat-list-option *ngFor="let topic of topics" style="height: 90px" [value]="topic" [disabled]="isExistingTopic(topic)" [selected]="isExistingTopic(topic)">
                <topic-image matListAvatar [topic]="topic" style="height: 80px; width: 80px; margin-bottom: 10px;"></topic-image>
                <span>{{topic.title}}</span>
            </mat-list-option>
        </mat-selection-list>
`})
export class TopicSelectionListComponent {
    @Output() selectionChange = new EventEmitter();
    @Input() topics: any[];
    @Input() existingTopicIds: string[];

    isExistingTopic(topic):boolean {
        return this.existingTopicIds.indexOf(topic.id) !== -1;
    }
}    